@use "../../../scss/settings/colors";

.preview_icon {
  position: absolute;
  bottom: 8px;
  right: 8px;
}

.card {
  position: relative;
  flex-shrink: 0;
  width: 235px;
  height: 205px;
  padding: 10px 16px;
  background-color: colors.$base-white;
  border-radius: 8px;
  transition: background-color 0.3s, box-shadow 0.3s;

  &:hover {
    background-color: colors.$purple-variant;
    box-shadow: 0 4px 4px 0 rgba(100, 20, 219, 0.25);
  }

}

.card_content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 !important;
}

.category_name_container {
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;

  + .icon_container {
    margin: auto;

    svg {
      margin-top: -24px;
    }

  }

}

.category_name {
  margin-bottom: 0;
  font-family: 'Medium Inter', sans-serif;
  font-size: 14px;
  color: colors.$dark-blue;
}

.category_description {
  margin-bottom: 16px;
  font-family: 'Regular Inter', sans-serif;
  font-size: 12px;
  color: colors.$dark-blue;
}

.icon_container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;

  svg {
    width: 70px;
    height: 70px;
  }

  svg:not([fill="none"]) {
    color: colors.$dark-blue !important;
    fill: colors.$dark-blue !important;
  }

}

.free_label, .new_label {
  position: absolute;
  bottom: 5px;
  right: 5px;
  display: inline-flex;
  padding: 4px 8px;
  font-family: 'Regular Inter', sans-serif;
  font-size: 10px;
  color: colors.$dark-blue;
  background-color: colors.$green-variant-light;
  border-radius: 5px;
}

.new_label {
  color: colors.$dark-blue;
  background-color: colors.$blue-variant-2;
}